import { en } from './en';
import { nl } from './nl';

export const i18nConfig = {
    resources: { en, nl },
    lng: /^nl\b/.test(navigator.language) ? 'nl' : 'en',
    fallbackLng: /^nl\b/.test(navigator.language) ? 'nl' : 'en',
    interpolation: {
        escapeValue: false,
    },
};
